// Hledání produktů pro admin sad (produkt sady, dárkové balení, komponenty,
// dárky) — sdílené mezi ProductSetModal a ProductSetGiftsSection.

import { apiFetch } from '@/lib/apiFetch';
import { useEffect, useRef, useState } from 'react';

export type Product = {
  shopitem_id: number;
  parent_code: string | null;
  name: string;
  image_url: string | null;
};

export function useProductSearch(eshopId: string) {
  const [query, setQuery] = useState('');
  const [results, setResults] = useState<Product[]>([]);
  const [searching, setSearching] = useState(false);
  const timer = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    if (timer.current) clearTimeout(timer.current);
    if (query.trim().length < 2) {
      setResults([]);
      return;
    }
    timer.current = setTimeout(async () => {
      setSearching(true);
      try {
        const params = new URLSearchParams({ q: query.trim(), limit: '20', eshop_id: eshopId });
        const data = await apiFetch<{ products: Product[] }>(
          `/api/propojeni/products?${params.toString()}`,
        );
        setResults(data.products);
      } catch {
        setResults([]);
      } finally {
        setSearching(false);
      }
    }, 250);
    return () => {
      if (timer.current) clearTimeout(timer.current);
    };
  }, [query, eshopId]);

  return { query, setQuery, results, searching };
}
